import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { Cross } from "../../../shared/assets/icons";
import axios from "axios";
import { downloadData } from "../../../shared/downloadData";
import { uploadExcelForPrintingProductsDimension } from "./uploadExcelForPrintingProductsDimension";

const ModalToCreatePrintingClusters = ({
  setOpenModalToCreateClustersForPrinting,
  openModalToCreateClustersForPrinting,
  campaignData,
}) => {
  const [newProducts, setNewProducts] = useState([]);
  const [dataForDownloadTemplate, setDataForDownloadTemplate] = useState([]);
  // const [availableJobs, setAvailableJobs] = React.useState([]);
  const [selectedJobs, setSelectedJobs] = useState([]);
  // const [expandedBatch, setExpandedBatch] = React.useState(null);
  const [openConfirmationModal, setOpenConfirmationModal] =
    React.useState(false);
  const fileInputForExcelRef = React.useRef(null);
  // handlers:
  const handleIconClickForExcel = () => {
    if (fileInputForExcelRef.current) {
      fileInputForExcelRef.current.click();
    }
  };
  // handlers
  // const handleAccordionToggle = (batchTitle) => (event) => {
  //   event.stopPropagation();
  //   setExpandedBatch((prev) => (prev === batchTitle ? null : batchTitle));
  // };

  const groupData = (data) => {
    const clusterGroups = {};

    data?.forEach((job) => {
      const { clusterId, batchId, ...jobDetails } = job;

      if (!clusterGroups[clusterId]) {
        clusterGroups[clusterId] = {};
      }

      if (!clusterGroups[clusterId][batchId]) {
        clusterGroups[clusterId][batchId] = [];
      }

      clusterGroups[clusterId][batchId].push(jobDetails);
    });

    return clusterGroups;
  };

  // const groupedData = groupData(rawData);
  // console.log(JSON.stringify(groupedData, null, 2));

  const handleInputChange = async (e) => {
    // const { name, value } = e.target;
    let response = await uploadExcelForPrintingProductsDimension(e);
    if (response?.success) {
      const groupedData = groupData(response.printingData);
      setSelectedJobs(groupedData);
      setNewProducts(response.printingData);
      // create new products
    }
  };

  const handleClose = () => setOpenModalToCreateClustersForPrinting(false);
  let serverURL = process.env.REACT_APP_URL;
  // Modal styles
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%", // Adjusted width
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "8px",
  };

  React.useEffect(() => {
    if (campaignData._id) {
      fetchAllJobsBasedOnCampaignId();
    }
  }, []);

  const addClusterIdToData = (dataForDownloadTemplate, batches) => {
    const batchClusterMap = new Map();
    // Create a map of batchId to clusterId
    batches.forEach((batch) => {
      batchClusterMap.set(batch._id, batch.idOfClusterOfBatchesForVendor);
    });

    // Add clusterId to each object in dataForDownloadTemplate
    const updatedData = dataForDownloadTemplate.map((item) => ({
      ...item,
      clusterId: batchClusterMap.get(item.batchId) || null, // Use null if batchId not found
    }));

    return updatedData;
  };

  const fetchAllJobsBasedOnCampaignId = async () => {
    try {
      const response = await axios.get(
        `${serverURL}/jobs/getAllJobs?campaignId=${campaignData._id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response?.data?.success) {
        // setAvailableJobs(response.data.data);
        let formattedJobs = await response?.data?.data?.map((job, index) => {
          return {
            id: index + 1,
            jobId: job._id,
            batchId: job.batchOfJobsForInstallationPartnerId,
            campaignId: campaignData._id,
            storeName: job.storeName,
            storeOwnerName: job.storeOwnerName,
            storeOwnerPhoneNumber: job.storeOwnerPhoneNumber,
            city: job.city,
            address: job.address,
            productHeight: job.product.productHeight,
            productWidth: job.product.productWidth,
            productId: job.product._id,
            printingProductWidth: "",
            printingProductHeight: "",
          };
        });
        setDataForDownloadTemplate(formattedJobs);
        fetchAllBatchesBasedOnCampaignId();
      }
    } catch (error) {
      console.error("error in while fetching jobs", error);
    }
  };
  const fetchAllBatchesBasedOnCampaignId = async () => {
    try {
      const response = await axios.get(
        `${serverURL}/batchOfJobs/getAllBatchJobs?campaignId=${campaignData._id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response?.data?.success) {
        // setAvailableBatches(response.data.data);
        setDataForDownloadTemplate((currentData) =>
          addClusterIdToData(currentData, response.data.data)
        );
      }
    } catch (error) {
      console.error("error in while fetching jobs", error);
    }
  };

  const saveCreatedClusters = async () => {
    try {
      const token = localStorage.getItem("token");
      const responseFromSaving = await axios.post(
        `${process.env.REACT_APP_URL}/vendorClusterBatches/createSecondaryClusters`,
        {
          selectedJobs,
          campaignId: campaignData._id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (responseFromSaving?.data.success) {
        setOpenConfirmationModal(false);
        setOpenModalToCreateClustersForPrinting(false);
        alert("Clusters created");
      }
    } catch (error) {
      console.error("Error while saving created Clusters", error);
    }
  };
  return (
    <div>
      <Modal open={openModalToCreateClustersForPrinting} onClose={handleClose}>
        <Box sx={modalStyle}>
          {/* Title */}
          <div className="flex justify-between">
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              {campaignData.campaignTitle}
            </Typography>
            <div className=" cursor-pointer" onClick={handleClose}>
              <Cross />
            </div>
          </div>
          {/* Tags */}
          <Box display="flex" gap={1} mb={3}>
            <Typography
              sx={{
                backgroundColor: "#E3F2FD",
                color: "#1E88E5",
                padding: "4px 8px",
                borderRadius: "4px",
                fontSize: "14px",
              }}
            >
              {`Product Category For Printing : ${campaignData?.scopeOfWork?.productCategoryForPrinting}`}
            </Typography>
          </Box>

          <div className="col-span-1 flex justify-center lg:justify-end gap-1">
            <button
              className="px-4 py-2 w-full lg:w-auto text-blue-500 flex items-center justify-center border border-blue-500 rounded-md hover:bg-blue-500 hover:text-white transition duration-300"
              onClick={() => {
                const fileName = `printingDimensionsTemplate.xlsx`;
                downloadData(
                  dataForDownloadTemplate,
                  headersForDownload,
                  fileName,
                  "xlsx"
                );
              }}
            >
              {/* <ArrowCircleDown className="mr-2" color="inherit" size={23} /> */}
              Download Product Template
            </button>
            <div>
              <input
                type="file"
                ref={fileInputForExcelRef}
                name={`locationsList`}
                onChange={async (e) => {
                  handleInputChange(e);
                }}
                style={{
                  display: "none",
                }}
                accept=".xlsx"
              />
              <button
                onClick={handleIconClickForExcel}
                className="px-2 py-2 w-32 cursor-pointer text-[var(--primary-color)] border-[var(--primary-color)] border rounded-md"
              >
                Import Template
              </button>
            </div>
          </div>
          {newProducts.length > 0 ? (
            <div>
              <div className="flex justify-between my-4 align-middle">
                <Typography variant="h6">
                  Total Products : {newProducts.length}
                </Typography>
              </div>
              <Box sx={{ overflow: "auto", maxHeight: "250px" }}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Length of Print Job</TableCell>
                        <TableCell>Width of Print Job</TableCell>
                        <TableCell>Product Image</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {newProducts.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell>{row?.printingProductHeight}</TableCell>
                          <TableCell>{row?.printingProductWidth}</TableCell>
                          <TableCell>
                            <img src={row?.printImage} alt="N/A" />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </div>
          ) : (
            <div>{`No Products Added`}</div>
          )}
          {/* Save and Edit Buttons */}
          <Box display="flex" justifyContent="space-between" mt={3}>
            {/* <Button variant="outlined">Edit</Button> */}
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setOpenConfirmationModal(true);
              }}
            >
              Save & Create Jobs
            </Button>
          </Box>
        </Box>
      </Modal>
      {openConfirmationModal && (
        <ConfirmationBeforeSaving
          saveCreatedClusters={saveCreatedClusters}
          setOpenConfirmationModal={setOpenConfirmationModal}
          openConfirmationModal
        />
      )}
    </div>
  );
};

export default ModalToCreatePrintingClusters;

const ConfirmationBeforeSaving = ({
  saveCreatedClusters,
  setOpenConfirmationModal,
  openConfirmationModal,
}) => {
  const handleClose = () => {
    setOpenConfirmationModal(false);
  };
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "25%", // Adjusted width
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "8px",
  };
  return (
    <Modal open={openConfirmationModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <div className="flex flex-col">
          <span>{`Are you sure you want to save following batches ?`}</span>
          <div className="flex gap-2 mt-2 justify-end">
            <Button variant="outlined" color="primary" onClick={handleClose}>
              No thanks.
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={saveCreatedClusters}
            >
              Yes, sure!
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

const headersForDownload = [
  { label: "storeName", key: "storeName" },
  { label: "storeOwnerName", key: "storeOwnerName" },
  { label: "storeOwnerPhoneNumber", key: "storeOwnerPhoneNumber" },
  { label: "city", key: "city" },
  { label: "address", key: "address" },
  { label: "productHeight", key: "productHeight" },
  { label: "productWidth", key: "productWidth" },
  { label: "productId", key: "productId" },
  { label: "jobId", key: "jobId" },
  { label: "batchId", key: "batchId" },
  { label: "clusterId", key: "clusterId" },
  { label: "printingProductHeight", key: "printingProductHeight" },
  { label: "printingProductWidth", key: "printingProductWidth" },
];
